export const select_options = {
  approval_options: [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
    { value: "Pending", label: "Pending" },
    // { value: "on_hold", label: "On Hold" },
  ],
  ud_options: [
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
    { value: "On Hold", label: "On Hold" },
    { value: "Pending", label: "Pending" },
  ],
};
export const approval_status_column_properties = {
  type: "singleSelect",
  valueOptions: [...select_options.approval_options],
};

export const approval_ud_date_column_properties = {
  type: "date",
  valueGetter: ({ value }) => {
    if (typeof value === "object") return value;
    // return value && convert_dd_mm_yy_to_Date(value);
    return value && new Date(value);
  },
};

export const ud_status_column_properties = {
  type: "singleSelect",
  valueOptions: [...select_options.ud_options],
};
